import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  getData,
  postData,
  deletData,
  putData,
} from "../../services/generalService";
import { DocumentsObj } from "../../utils/types";

const initialState: DocumentsObj = {
  data: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  isGenerateDocsLoading: false,
};

export const getuploadDocumentsUrl = createAsyncThunk(
  "getuploadDocumentsUrl",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

export const uploadDocuments = createAsyncThunk(
  "documentsUpload",
  async (pData: { url: string; data: any }, thunkAPI) => {
    try {
      const data = await postData(pData.url, pData.data);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

export const generateDocuments = createAsyncThunk(
  "generateDocuments",
  async (pData: { url: string; data: any }, thunkAPI) => {
    try {
      const data = await postData(pData.url, pData.data);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

export const deleteDocuments = createAsyncThunk(
  "deleteUpload",
  async (url: string, thunkAPI) => {
    try {
      const data = await deletData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

export const updateDocuments = createAsyncThunk(
  "documentsUpdate",
  async (pData: { url: string; data: any }, thunkAPI) => {
    try {
      const data = await putData(pData.url, pData.data);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const uploadDocumentsSlice = createSlice({
  name: "uploadDocuments",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getuploadDocumentsUrl.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getuploadDocumentsUrl.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getuploadDocumentsUrl.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      })
      .addCase(uploadDocuments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadDocuments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(uploadDocuments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      })
      .addCase(generateDocuments.pending, (state) => {
        state.isGenerateDocsLoading = true;
        state.isLoading = false;
      })
      .addCase(generateDocuments.fulfilled, (state, action) => {
        state.isGenerateDocsLoading = false;
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(generateDocuments.rejected, (state, action) => {
        state.isGenerateDocsLoading = false;
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      })
      .addCase(updateDocuments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateDocuments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(updateDocuments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      })
      .addCase(deleteDocuments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteDocuments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
      })
      .addCase(deleteDocuments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default uploadDocumentsSlice.reducer;
